import React from "react";
import * as notify from "../../../shared/notify";
import { useRejectToSupplier } from "components/photography/hooks/api/use-reject-to-supplier";

export const RejectToSupplier = ({ wipKey, onComplete, isUploading, disabled, workflowType }) => {
    const { mutate: rejectProduct } = useRejectToSupplier();

    const handleReject = async () => {
        const prompt = await notify.prompt(
            "Are you sure you want to reject this item back to the Supplier? The item will be removed from the Intake queue and cannot be undone.<br /><br /> Reason*",
            [],
            { yesLabel: "Reject", noLabel: "Cancel" }
        );

        if (!prompt) {
            if (typeof prompt === "string") {
                notify.error("Reject reason required");
            }

            return false;
        }

        const payload = workflowType ? { reason: prompt, workflowType: workflowType } : { reason: prompt };

        rejectProduct(
            { wipKey, payload },
            {
                onError: () => {
                    return false;
                },
                onSuccess: (response) => {
                    if (response) {
                        onComplete();
                    }
                },
            }
        );
    };

    return (
        <button
            className="button -error"
            onClick={handleReject}
            disabled={isUploading || disabled}
        >
            Reject To Supplier
        </button>
    );
};
